import { useEffect, useState } from "react";
import { useEditAdminProfileMutation, useGetAdminProfileQuery } from "../../Services/DasboardAPI";

function AddStock() {
    const [formData, setFormData] = useState({
        name: "",
        fullname: "",
        email: "",
        contact_email: "",
    });

    const [errors, setErrors] = useState({});

    const [updateStock, { isLoading: updateLoading }] = useEditAdminProfileMutation();
    const { data: contentDetail, isLoading: loadingContent, error, refetch: refetchcontentDetail } = useGetAdminProfileQuery();

    const [apiError, setApiError] = useState(null);
    console.log("contentDetail", contentDetail)
    useEffect(() => {
        refetchcontentDetail();
    }, [refetchcontentDetail]);

    useEffect(() => {

        const existingData = contentDetail;
        setFormData({
            name: existingData?.name || "",
            fullname: existingData?.fullname || "",
            email: existingData?.email || "",
            contact_email: existingData?.contact_email || "",

        });

    }, [contentDetail]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" })); // Clear error when user types
    };

    const validateForm = () => {
        const newErrors = {};
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // const urlPattern = /^(https?:\/\/)?([\w\d-]+\.)+[\w\d]{2,}(\/.+)?$/;

        if (!formData.email) {
            newErrors.email = "Email is required";
        } else if (!emailPattern.test(formData.email)) {
            newErrors.email = "Invalid email format";
        }

        // if (formData.website && !urlPattern.test(formData.website)) {
        //     newErrors.website = "Invalid website URL";
        // }

        // ["facebook", "twitter", "instagram", "youtube"].forEach(field => {
        //     if (formData[field] && !urlPattern.test(formData[field])) {
        //         newErrors[field] = `Invalid URL for ${field}`;
        //     }
        // });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {

            let formDataToSend = {
                name: formData.name,
                fullname: formData.fullname,
                email: formData.email,
                contact_email: formData.contact_email
            }
            await updateStock(formDataToSend).unwrap();
            alert("Profile Updated Successfully")
        } catch (error) {
            setApiError(error.data?.message || "Something went wrong");
            setTimeout(() => {
                setApiError("");
            }, 3000);
        }
    };

    if (loadingContent) return <div class="loader"></div>;
    if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            <h3>Edit Profile</h3>
            {/* <div className="breadcrum mb-4">
                <p>
                    <FontAwesomeIcon icon={faAngleLeft} className="mx-2" />
                    <Link to="/about"><span>Back</span></Link>
                </p>
            </div> */}
            <div className="content-wrapper">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        {Object.keys(formData).map((key) => (
                            <div className="col-md-6 col-sm-12 col-lg-6" key={key}>
                                <div className="mb-4 text-start">
                                    <label htmlFor={key} className="form-label">
                                        {key === "content"
                                            ? "Reach Out to Us Content" // Custom label for 'content' field
                                            : key
                                                .replace(/_/g, ' ') // Replace underscores with spaces
                                                .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
                                                .replace(/\b(Facebook|Instagram|Twitter|Youtube)\b/, '$1 Link') // Add 'Link' for social media
                                        }
                                    </label>

                                    {key === "address" || key === "content" ? (
                                        <textarea
                                            className="form-control"
                                            id={key}
                                            name={key}
                                            placeholder={`Enter ${key.replace(/_/g, ' ')}`}
                                            value={formData[key]}
                                            onChange={handleChange}
                                        ></textarea>
                                    ) : (
                                        <input
                                            type="text"
                                            className="form-control"
                                            id={key}
                                            name={key}
                                            placeholder={`Enter ${key.replace(/_/g, ' ')}`}
                                            value={formData[key]}
                                            onChange={handleChange}
                                        />
                                    )}
                                    {errors[key] && <p className="text-danger">{errors[key]}</p>}
                                </div>
                            </div>
                        ))}
                    </div>
                    {apiError && <p className="text-danger text-center">{apiError}</p>}
                    <button type="submit" className="btn btn-primary" disabled={updateLoading}>
                        {updateLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AddStock;
